import React, { memo } from 'react';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { FinancialPerformanceIndicatorsHeader } from './financial-performance-indicators-header';
import { FinancialPerformanceIndicatorsContent } from './financial-performance-indicators-content';
import { Block } from '../../components/core';
import { NoStrategyLevelsSelectedErrorWrapper } from '../../../studio-blocks/components/error-wrappers/NoStrategyLevelsSelectedErrorWrapper';

export const FinancialPerformanceIndicatorsBlock = memo(function InternalFPIBlock({ id }: { id: string }) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <FinancialPerformanceIndicatorsHeader id={id} />
      </Block.Header>
      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS, NoStrategyLevelsSelectedErrorWrapper]}>
        <FinancialPerformanceIndicatorsContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
